/* eslint-disable jira/filename-case */
export type SamplingConfig = {
	//  Regex to match the error type (make as specific as possible)
	matcher: RegExp;
	//  Additional match criteria based on url (checked via .endsWith)
	route?: string | undefined;
	//  Rate at which we sample events (10000 = 1/10000 events)
	//  Change accordingly to aim for volume of >1000 per day
	samplingRate: number;
};

/**
 * BEFORE adding a new sampling configuration:
 * - Ensure no recent change in volume for the error type
 * - Talk to the owners of the error. Confirm there is no other easy fix
 * - Create an issue to improve signal to noise for the error type
 */
const SENTRY_SAMPLING_CONFIG: SamplingConfig[] = [
	{
		// Ignore postrobot errors triggered by forge as team won't fix
		// https://atlassian.slack.com/archives/C03MMQ1B39V/p1671517439783989
		matcher: /postrobot_method/,
		samplingRate: 0,
	},
	{
		// Ignore e.source.postMessage from monolith Connect JS as caused by callback on a closed window
		// https://atlassian.slack.com/archives/CFGTZ99TL/p1677032642940009
		matcher: /postMessage'\)/,
		samplingRate: 0,
	},
	{
		// JFP-1542
		matcher:
			/^\[Frontend PubSub\] Failed to retrieve subscription configuration \[object Object\]$/,
		samplingRate: 10,
	},
	{
		// Filter out local storage quota exceeded errors for atlassian-analytics.jira.lock
		// Non-actionable browser quota limitation errors that create noise in Sentry
		matcher: /Setting the value of 'atlassian-analytics\.jira\.lock' exceeded the quota/,
		samplingRate: 0,
	},
	{
		// Filter out local storage quota exceeded errors for the storejs feature probe
		// Temporary, pending the browser-storage-controls localStorage proxy fix - YUZ-2376
		matcher: /Setting the value of '__storejs__test__' exceeded the quota/,
		samplingRate: 0,
	},
];

export default SENTRY_SAMPLING_CONFIG;
